module.exports = __webpack_public_path__ + "img/icon_arrow_right.27e0f2f8.png";